import { Fullscreen } from "lucide-react";
import { Button } from "./ui/button";
import { cn } from "../../utils/helper-funcs";

interface FullScreenButtonProps {
  className?: string;
}

export function FullScreenButton({ className }: FullScreenButtonProps) {
  const toggleFullScreen = () => {
    if (!document) return;
    if (
      !(document as any).fullscreenElement &&
      !(document as any).webkitFullscreenElement &&
      !(document as any).mozFullScreenElement &&
      !(document as any).msFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen().catch((e) => {
          console.error(
            `Error attempting to enable full-screen mode: ${e.message} (${e.name})`,
          );
        });
      } else if ((document.documentElement as any).webkitRequestFullscreen) {
        (document.documentElement as any)
          .webkitRequestFullscreen()
          .catch((e) => {
            console.error(
              `Error attempting to enable full-screen mode: ${e.message} (${e.name})`,
            );
          });
      } else if ((document.documentElement as any).mozRequestFullScreen) {
        (document.documentElement as any).mozRequestFullScreen().catch((e) => {
          console.error(
            `Error attempting to enable full-screen mode: ${e.message} (${e.name})`,
          );
        });
      } else if ((document.documentElement as any).msRequestFullscreen) {
        (document.documentElement as any).msRequestFullscreen().catch((e) => {
          console.error(
            `Error attempting to enable full-screen mode: ${e.message} (${e.name})`,
          );
        });
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if ((document as any).webkitExitFullscreen) {
        (document as any).webkitExitFullscreen();
      } else if ((document as any).mozCancelFullScreen) {
        (document as any).mozCancelFullScreen();
      } else if ((document as any).msExitFullscreen) {
        (document as any).msExitFullscreen();
      }
    }
  };
  return (
    <button onClick={toggleFullScreen}>
      <Fullscreen size={16} />
    </button>
  );
}
